module.exports = __webpack_public_path__ + "media/images/edools_logo-6d74ad6c244786345629b1665ac5028b.png";